export const TASK_CONFIGS = {
  bulkCapeAnalyticsRoofAgeReport: {
    columnOrder: ['Policy Id', 'Roof Year', 'Cape Roof Year', 'Cape Roof Year Confidence Score', 'Coverage Type']
  }
};

export const getTaskConfig = (taskName) => {
  return TASK_CONFIGS[taskName] || null;
};
